import { useLocation } from "react-router-dom";
import { React, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import api from "../../../api/api";
import AllDocumentList from "./AllDocumentList";

const CompanyEdit = () => {
  const { state } = useLocation();
  console.log("state", state);

  const [companyList, setCompanyList] = useState({});
  const { register, handleSubmit, setValue } = useForm();

  const handleSub = (data) => {
    api
      .patch(`/services/company/${state.companyListId.id}/`, data)
      .then((respone) => {
        toast.success("Data updated successfully");
      })
      .catch((error) => {
        toast.error("Something went wrong");
      });
  };

  useEffect(() => {
    if (state.companyListId !== null) {
      api
        .get(`/services/company/?id=${state.companyListId.id}`)
        .then((response) => {
          setCompanyList(response.data[0]);
        })
        .catch((error) => {
          // toast.error("Something Went Wrong")
          console.log(error);
        });
    }
  }, []);
  return (
    <div className="md:px-10 px-4">
      <h1 className="text-center text-primary-red  my-5 font-Calistoga text-2xl mb-5 underline">
        Company Details
      </h1>

      <form onSubmit={handleSubmit(handleSub)}>
        <div className="grid grid-cols-1 border-2 font-semibold border-primary-blue md:grid-cols-2   font-Laila">
          <div className="border-b md:border-r border-primary-blue p-2">
            <label className="text-primary-red" htmlFor="">
              कम्पनी दर्ता नं :
            </label>
            <input
              type="text"
              className="pl-2 ml-2 outline-none  w-36 md:w-60 font-Calistoga text-primary-blue"
              {...register(
                "regd_number",
                { required: true },
                setValue("regd_number", companyList.regd_number)
              )}
            />
          </div>
          <div className="border-b  border-primary-blue p-2">
            <label className="text-primary-red" htmlFor="">
              कम्पनी दर्ता मिती :
            </label>
            <input
              type="text"
              className="pl-2 ml-2 outline-none w-32 md:w-60 font-Calistoga text-primary-blue"
              {...register(
                "regd_date",
                { required: true },
                setValue("regd_date", companyList.regd_date)
              )}
            />
          </div>

          <div className="border-b md:border-r border-primary-blue p-2">
            <label className="text-primary-red" htmlFor="">
              कम्पनको नाम :
            </label>
            <input
              type="text"
              placeholder="अंग्रेजीमा"
              {...register(
                "company_name",
                { required: true },
                setValue("company_name", companyList.company_name)
              )}
              className="pl-2 ml-2 outline-none w-36 md:w-60 font-Calistoga text-primary-blue"
            />
          </div>

          <div className="border-b  border-primary-blue p-2">
            <label className="text-primary-red" htmlFor="">
              कम्पको नाम :
            </label>
            <input
              type="text"
              placeholder="नेपालीमा"
              {...register(
                "company_name_nep",
                { required: true },
                setValue("company_name_nep", companyList.company_name_nep)
              )}
              className="pl-2 ml-2 outline-none w-36 md:w-60 font-Calistoga text-primary-blue"
            />
          </div>
          <div className="border-b md:border-r border-primary-blue p-2">
            <label className="text-primary-red" htmlFor="">
              कम्पनीको ठेगाना:
            </label>
            <input
              type="text"
              className="pl-2 ml-2 outline-none w-32 md:w-60 font-Calistoga text-primary-blue"
              {...register(
                "company_address",
                { required: true },
                setValue("company_address", companyList.company_address)
              )}
            />
          </div>
          <div className="border-b  border-primary-blue p-2">
            <label className="text-primary-red" htmlFor="">
              कम्पनीको प्रकार :
            </label>

            {companyList.business_type === "ekal" ? (
              <>
                <input
                  {...register(
                    "business_type",
                    { required: true },
                    setValue("business_type", "ekal")
                  )}
                  type="radio"
                  id="ekal"
                  name="company_type"
                  checked={true}
                  className="pl-2 mx-2 outline-none   font-Calistoga text-primary-blue"
                />

                <label className="text-primary-red" htmlFor="ekal">
                  एकल
                </label>
                <input
                  type="radio"
                  id="typebahul"
                  {...register(
                    "business_type",
                    { required: true },
                    setValue("business_type", "bahul")
                  )}
                  name="company_type"
                  className="pl-2 mx-2 outline-none   font-Calistoga text-primary-blue"
                />
                <label className="text-primary-red" htmlFor="typebahul">
                  बहुल
                </label>
              </>
            ) : (
              <>
                <input
                  type="radio"
                  id="typeekal"
                  checked={true}
                  {...register(
                    "business_type",
                    { required: true },
                    setValue("business_type", "ekal")
                  )}
                  name="company_type"
                  className="pl-2 mx-2 outline-none   font-Calistoga text-primary-blue"
                />
                <label className="text-primary-red" htmlFor="typebahul">
                  एकल
                </label>

                <input
                  {...register(
                    "business_type",
                    { required: true },
                    setValue("business_type", "bahul")
                  )}
                  type="radio"
                  id="bahul"
                  name="company_type"
                  className="pl-2 mx-2 outline-none   font-Calistoga text-primary-blue"
                />

                <label className="text-primary-red" htmlFor="ekal">
                  बहुल
                </label>
              </>
            )}
          </div>
          <div className="border-b md:border-r font-Calistoga border-primary-blue p-2">
            <label className="text-primary-red" htmlFor="">
              PAN No:
            </label>
            <input
              type="text"
              className="pl-2 ml-2 outline-none w-36 md:w-60 font-Calistoga text-primary-blue"
              {...register(
                "company_pan",
                { required: true },
                setValue("company_pan", companyList.company_pan)
              )}
            />
          </div>
          <div className="border-b flex flex-wrap font-Calistoga  border-primary-blue p-2">
            <label className="text-primary-red" htmlFor="">
              Tax Type :
            </label>
            <div>
              <input
                type="checkbox"
                id="pan"
                name="tax-type"
                className="pl-2 ml-2 outline-none mx-2 font-Calistoga text-primary-blue"
              />
              <label className="text-primary-red" htmlFor="pan">
                Pan
              </label>
              <input
                type="checkbox"
                id="vat"
                name="tax-type"
                className="pl-2 ml-2 outline-none mx-2 font-Calistoga text-primary-blue"
              />
              <label className="text-primary-red" htmlFor="vat">
                VAT ,
              </label>
            </div>
            <div className="">
              <label className="text-primary-red" htmlFor="">
                (Entry :
              </label>
              <input
                type="checkbox"
                id="self"
                name="tax-type"
                className="pl-2 ml-2 outline-none mx-2 font-Calistoga text-primary-blue"
              />
              <label className="text-primary-red" htmlFor="self">
                Self
              </label>
              <input
                type="checkbox"
                id="office"
                name="tax-type"
                className="pl-2 ml-2 outline-none mx-2 font-Calistoga text-primary-blue"
              />
              <label className="text-primary-red" htmlFor="office">
                Office)
              </label>
            </div>
          </div>

          <div className="border-b flex font-Calistoga flex-wrap md:border-b-0 md:border-r border-primary-blue p-2">
            <label className="text-primary-red" htmlFor="">
              Contact Person Name :
            </label>
            <input
              type="text"
              {...register(
                "contact_person",
                { required: true },
                setValue("contact_person", companyList.contact_person)
              )}
              className="pl-2 ml-2 outline-none w-36  md:w-40 font-Calistoga text-primary-blue"
            />
          </div>
          <div className="font-Calistoga border-primary-blue p-2">
            <label className="text-primary-red" htmlFor="">
              Contact No :
            </label>
            <input
              type="text"
              {...register(
                "conatact_number",
                { required: true },
                setValue("conatact_number", companyList.conatact_number)
              )}
              className="pl-2 ml-2 w-36 md:w-60 outline-none font-Calistoga text-primary-blue"
            />
          </div>
        </div>
        <div className="border-b-2 border-x-2 text-center flex flex-wrap border-primary-blue p-2">
          <label className="text-primary-red" htmlFor="">
            Company Type :{" "}
          </label>

          {/* <p> &nbsp;{companyType}</p> */}

          {/* <input
              type="checkbox"
              id="newcompany"
              name="tax-type"
              {...register(
                "conatact_number",
                { required: true },
                setValue("conatact_number", companyList.conatact_number)
              )}
              className="pl-2 ml-2 outline-none mx-2 font-Calistoga text-primary-blue"
            /> */}
          {/* <label htmlFor="newcompany">New Company</label>
            <input
              type="checkbox"
              id="oldcompany"
              name="tax-type"
              // company_type
              {...register(
                "conatact_number",
                { required: true },
                setValue("conatact_number", companyList.conatact_number)
              )}
              className="pl-2 ml-2 outline-none mx-2 font-Calistoga text-primary-blue"
            />
            <label htmlFor="oldcompany">Old Company</label>
            <input
              type="checkbox"
              id="other"
              checked
              name="tax-type"
              className="pl-2 ml-2 outline-none mx-2 font-Calistoga text-primary-blue"
            />
            <label htmlFor="other">Other Bussiness</label> */}
        </div>
        <div className="mx-5 mb-5 mt-2  ">
          <input
            className="bg-primary-red  text-white float-right rounded-full px-3 cursor-pointer "
            type="submit"
            value="Submit"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
          {/* Submit1
            </button> */}
        </div>
      </form>

      <h1 className=" flex justify-center my-5 text-primary-red font-Calistoga text-2xl mb-5 underline">
        Use For Social Media
      </h1>

      <div className="flex flex-wrap w-full flex-1  border-primary-blue border ">
        <div className="flex gap-2 flex-1 items-center md:border-r border-primary-red p-2">
          <label className="text-primary-red" htmlFor="">
            Email:
          </label>
          <input type="text" name="" id="" />
        </div>
        <div className="flex gap-2 items-center flex-1 md:border-r border-primary-red p-2">
          <label className="text-primary-red" htmlFor="">
            Messenger Link :
          </label>
          <input className="md:w-28 " type="text" name="" id="" />
        </div>
        <div className="flex gap-2 items-center flex-1 md:border-r border-primary-red p-2">
          <label className="text-primary-red" htmlFor="">
            Viber :
          </label>
          <input className="md:w-24 " type="text" name="" id="" />
        </div>
        <div className="flex gap-2 items-center flex-1 md:border-r border-primary-red p-2">
          <label className="text-primary-red" htmlFor="">
            WhatsApp :
          </label>
          <input className="md:w-24 " type="text" name="" id="" />
        </div>
      </div>

      <h1 className="text-center my-5 text-primary-red font-Calistoga text-2xl mb-5 underline">
        Capital Structure
      </h1>

      <div className="flex flex-wrap w-full flex-1  border-primary-blue border ">
        <div className="flex gap-2 flex-1 border-b md:border-b-0 items-center md:border-r border-primary-red p-2">
          <label className="text-primary-red" htmlFor="">
            Authorized Capital :
          </label>
          <input className="w-40" type="text" name="" id="" />
        </div>
        <div className="flex gap-2 items-center border-b md:border-b-0 flex-1 md:border-r border-primary-red p-2">
          <label className="text-primary-red" htmlFor="">
            Issued Capital :
          </label>
          <input className="w-40 " type="text" name="" id="" />
        </div>
        <div className="flex gap-2 items-center flex-1 md:border-r border-primary-red p-2">
          <label className="text-primary-red" htmlFor="">
            Paid up capital :
          </label>
          <input className=" " type="text" name="" id="" />
        </div>
      </div>

      {/* Share Holder Details */}
      <h1 className="text-center my-5 text-primary-red font-Calistoga text-2xl mb-5 underline">
        Shareholder's List
      </h1>
      <table className="border-primary-blue min-w-full border my-5 text-center">
        <thead className="font-Bree bg-primary-red text-lg font-bold">
          <tr className="">
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              SN.
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Shareholder's Name
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Address
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Post :
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Share QTY.
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Share Amount.
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Share in %
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Nagarikta
            </th>
          </tr>
        </thead>
        <tbody>
          {" "}
          <tr className="">
            <td className=" text-primary-blue border border-primary-blue">1</td>
            <td className=" text-primary-blue border  border-primary-blue">
              ABC Company
            </td>
            <td className=" text-primary-blue border border-primary-blue">
              Bharatpur
            </td>
            <td className=" text-primary-blue border border-primary-blue">2</td>
            <td className=" text-primary-blue border border-primary-blue">
              Arjun
            </td>
            <td className=" text-primary-blue border border-primary-blue">
              Contact no.
            </td>
            <td className=" text-primary-blue border border-primary-blue">
              test Remarks
            </td>
            <td className="flex gap-2 justify-center items-center p-2 text-sm">
              <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
                Process
              </button>
              <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
                No Entery
              </button>
              <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
                Complete
              </button>
            </td>
          </tr>
        </tbody>
        <tbody>
          <tr></tr>
        </tbody>
      </table>
      <AllDocumentList/>
    </div>
  );
};

export default CompanyEdit;
